import Questionnare from './Questionnare'
export default Questionnare
